const getErrorMessage = async (response: Response) => {
  const res = await response.json();
  if (res.errors && res.errors.length) {
    return res.errors;
  } else if (res.debugMessage) {
    return new Array(res.debugMessage);
  } else {
    return new Array(res.message);
  }
};

export const handleErrors = async (response: Response) => {
  let res = null;
  if (!response.ok) {
    throw await getErrorMessage(response);
  } else {
    if (response.status === 204) {
      return res;
    } else {
      res = await response.json();
      if (typeof res === "object" && "totalPages" in res) {
        const pageObject = Object.assign({}, res);
        delete pageObject.content;
        return {
          data: res.content,
          pagination: pageObject,
        };
      } else {
        return res;
      }
    }
  }
};
